import { environment } from '@env/environment';

export class CookieUtils {
  static readonly sameSite = 'Lax';

  static isSecureConnection(
    protocol: string = globalThis.location.protocol
  ): boolean {
    return protocol === 'https:';
  }

  static getSharedDomain(
    hostname: string = globalThis.location.hostname
  ): string | undefined {
    const { enabled, baseDomain } = environment.subdomainOrgFilter ?? {};

    if (!enabled || !baseDomain) {
      return undefined;
    }

    const isOnBaseDomainFamily =
      hostname === baseDomain || hostname.endsWith(`.${baseDomain}`);

    return isOnBaseDomainFamily ? `.${baseDomain}` : undefined;
  }
}
